import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Box,
  Chip,
  Fade,
  Zoom,
  Checkbox
} from "@material-ui/core";
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';

const useStyles = makeStyles((theme) => ({
  card: {
    width: 240,
    minHeight: 200,
    textAlign: "center",
    borderRadius: 8,
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    transition: "all 0.2s ease",
    cursor: "pointer",
    position: 'relative',
    overflow: 'hidden',
    "&:hover": {
      transform: "translateY(-2px)",
      borderColor: 'rgb(15, 59, 98)',
      background: '#f8fafc',
    },
  },
  cardContent: {
    padding: '16px 12px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  avatarContainer: {
    position: 'relative',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'center',
  },
  avatar: {
    width: 60,
    height: 60,
    border: '2px solid rgb(15, 59, 98)',
    transition: 'all 0.2s ease',
    background: 'rgb(15, 59, 98)',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  },
  avatarBadge: {
    position: 'absolute',
    bottom: '2px',
    right: 'calc(50% - 30px - 2px)',
    width: '16px',
    height: '16px',
    backgroundColor: '#10b981',
    borderRadius: '50%',
    border: '2px solid #ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '8px',
    color: 'white',
    fontWeight: 'bold',
  },
  name: {
    fontWeight: 600,
    fontSize: "0.95rem",
    color: "rgb(15, 59, 98)",
    marginBottom: '6px',
    lineHeight: 1.3,
  },
  className: {
    color: "#64748b",
    fontSize: "0.8rem",
    fontWeight: 500,
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
  },
  classChip: {
    backgroundColor: 'rgb(15, 59, 98)',
    color: '#ffffff',
    fontWeight: 500,
    fontSize: '0.7rem',
    padding: '3px 8px',
    borderRadius: '4px',
    border: 'none',
    marginBottom: '8px',
    display: 'inline-block',
  },
  studentInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: 'auto',
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    fontSize: '0.75rem',
    color: '#64748b',
    fontWeight: 500,
  },
  icon: {
    fontSize: '14px',
    color: 'rgb(15, 59, 98)',
  },
  selectedCard: {
    background: '#f0f9ff',
    border: '2px solid rgb(15, 59, 98)',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(15, 59, 98, 0.15)',
  },
  checkbox: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    zIndex: 2,
    '& .MuiCheckbox-root': {
      padding: '4px',
      color: 'rgb(15, 59, 98)',
    },
    '& .MuiCheckbox-colorPrimary.Mui-checked': {
      color: 'rgb(15, 59, 98)',
    },
  },
  pulse: {
    animation: '$pulse 2s infinite',
  },
 
}));

export default function StudentCards({ studentList, onStudentSelect, selectedStudentId }) {
  const classes = useStyles();
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <Grid container spacing={4} justifyContent="center">
      {studentList.map((student, index) => {
        const isSelected = selectedStudentId === student._id;
        const isHovered = hoveredCard === student._id;
        
        return (
          <Grid item key={student._id}>
            <Zoom in={true} timeout={300 + (index * 100)}>
              <Card
                className={`${classes.card} ${isSelected ? classes.selectedCard : ''} ${isHovered ? classes.pulse : ''}`}
                onClick={() => onStudentSelect(
                  student._id,
                  student.classId?._id || student.classId,
                  student.dob
                )}
                onMouseEnter={() => setHoveredCard(student._id)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{ position: 'relative' }}
              >
                {/* Checkbox for selected state */}
                {isSelected && (
                  <Box className={classes.checkbox}>
                    <Checkbox
                      checked={true}
                      size="small"
                      color="primary"
                      readOnly
                    />
                  </Box>
                )}
                <CardContent className={classes.cardContent}>
                  {/* Avatar Section */}
                  <Box className={classes.avatarContainer}>
                    <Avatar
                      className={classes.avatar}
                      src={student.profileURL || student.imageURL?.[0] || "/images/Admin icon.svg"}
                      alt={student.fullName}
                    >
                      <PersonIcon style={{ fontSize: 30, color: 'white' }} />
                    </Avatar>
                  </Box>

                  {/* Student Info Section */}
                  <Box>
                    <Typography className={classes.name}>
                      {student.fullName}
                    </Typography>
                    
                    <Box className={classes.className}>
                      <SchoolIcon className={classes.icon} />
                      <span>Class: {student.classId?.className || 'N/A'}</span>
                    </Box>

                   
                  </Box>

                
                </CardContent>
              </Card>
            </Zoom>
          </Grid>
        );
      })}
    </Grid>
  );
}
